import { c as _c } from "react/compiler-runtime";
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import { Layout as AppLayout, Footer } from '@onefootprint/idv';
import type React from 'react';
import useHostedMachine from 'src/hooks/use-hosted-machine';
import SandboxBanner from './components/sandbox-banner';
type LayoutProps = {
  children: React.ReactNode;
  variant?: FootprintVariant;
};
const Layout = t0 => {
  const $ = _c(12);
  const {
    children,
    variant
  } = t0;
  const [state] = useHostedMachine();
  const {
    onboardingConfig
  } = state.context;
  const isSandbox = onboardingConfig?.isLive === false;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SandboxBanner />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hideDesktopSandboxBanner: true,
      hideDesktopFooter: true,
      hasDesktopBorderRadius: true
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== isSandbox || $[4] !== onboardingConfig || $[5] !== variant) {
    t3 = <div className="relative flex justify-center flex-1 md:[--footer-height:130px] md:h-[calc(100%-var(--footer-height))] md:items-center"><AppLayout config={onboardingConfig} variant={variant} isSandbox={isSandbox} isHosted={true} options={t2}>{children}</AppLayout></div>;
    $[2] = children;
    $[3] = isSandbox;
    $[4] = onboardingConfig;
    $[5] = variant;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onboardingConfig) {
    t4 = <div className="hidden md:block!"><Footer config={onboardingConfig} className="justify-center gap-6 mb-2" /></div>;
    $[7] = onboardingConfig;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col h-screen justify-between">{t1}{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default Layout;